import { defineView } from "@/ReactSetup/view-definitions";

const definition = defineView({
    name: "CalendarEventSlider",
    component: () => (__SERVER__ ? require("./event-slider-view") : import("./event-slider-view"))
});

export default definition;
